export const ERROR_CODES = {
  USER_BLOCKED: 4031412,
};
